import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {AuthHttp, AuthHttpError} from 'angular2-jwt';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Log} from 'ng2-logger';
import {AdminService} from './admin.service';
import {Permissions} from './permissions';
import {zip} from 'rxjs/observable/zip';
import {of} from 'rxjs/observable/of';

import 'rxjs/add/operator/map';

import {ACLFeature} from '../_models/acl-feature';
import { OidcService } from '../auth/oidc.service';
import { switchMap } from 'rxjs/operator/switchMap';

const log = Log.create('AuthenticationService');

@Injectable()
export class AuthenticationService implements CanActivate {
  constructor(private http: Http,
              private admin: AdminService,
              private router: Router,
              private oidcService: OidcService,
              private permissions: Permissions,
              private authHttp: AuthHttp) {}

  /**
   * Log error
   * @param err
   * @private
   */
  private _logError(err: Response | AuthHttpError): void {
    if (err instanceof AuthHttpError) {
      log.error('logError', err.message);
    } else {
      const body = err.json();
      switch (err.status) {
        case 401:
        default:
          this.router.navigate(['login']);
          break;
      }
    }
  }

  /**
   * Determine redirect url after login for role
   * @returns {Array<string>}
   */
  getRedirectAfterLogin(): Observable<any> {
      return zip(...[
        this.permissions.hasFeature(ACLFeature.READ_MODULES),
        this.permissions.hasFeature(ACLFeature.READ_MODULES),
        this.permissions.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO),
        this.permissions.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO),
        this.permissions.hasFeature(ACLFeature.READ_SENSORS),
      ], (canEditModules, canEditDrivers, canExportModule, canExportDriver, canReadSensors) => {
        if (canEditModules) {
          return ['/drilldown/modules'];
        } else if (canEditDrivers) {
          return ['/drilldown/drivers'];
        } else if (canExportDriver || canExportModule) {
          return ['/management'];
        } else if (canReadSensors) {
          return ['/drilldown/sensors'];
        }
      });
  }

  /**
   *
   * @param {ActivatedRouteSnapshot} next
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.oidcService.getUserOnce()
      .switchMap(() => {
        return this.permissions.canVisit(next.url);
      });
  }

  /**
   * Logout
   * @returns {Observable<string>}
   */
  logout(): Observable<string> {
    this.oidcService.signoutRedirect();
    return of('success');
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts